import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const AddTripIcon = ({
  width = '101',
  height = '101',
  className = ''
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-[#F9F9F9] hover:fill-primary-1 ${className ?? ''}`}
    >
      <circle cx="50.0006" cy="50.3404" r="50.0006" />
      <path
        d="M83.083 73.1247L78.9733 72.9856L78.9982 72.8409C79.086 72.3309 79.0982 71.8107 79.0344 71.2971C78.9743 70.8133 78.8474 70.3402 78.6573 69.8913L78.5746 69.696C78.4505 69.4029 78.3003 69.1217 78.1257 68.8556L78.1006 68.8172C77.7376 68.2639 77.2699 67.787 76.7237 67.4134C76.2576 67.0946 75.7415 66.856 75.1968 66.7072L75.0777 66.6747C74.5797 66.5388 74.0657 66.4699 73.5495 66.4699H73.1904C72.5975 66.4699 72.0096 66.5788 71.4559 66.7911C70.9758 66.9752 70.5282 67.2346 70.1296 67.5594L70.0385 67.6337C69.6243 67.9714 69.2639 68.37 68.9694 68.8159C68.6015 69.3729 68.3427 69.9947 68.2066 70.6482L68.1872 70.7419C68.0546 71.3787 68.0305 72.0335 68.116 72.6784L68.177 73.1382L44.6798 73.2389L44.6965 73.1543C44.8368 72.4419 44.847 71.7101 44.7267 70.9941L44.6918 70.7861C44.5751 70.0918 44.3139 69.4298 43.925 68.8429C43.5137 68.2223 42.9697 67.7008 42.3323 67.3161L42.1813 67.2249C41.539 66.8373 40.8252 66.5829 40.0824 66.4769L40.0089 66.4664C39.2462 66.3576 38.469 66.4177 37.7321 66.6425C37.1112 66.8319 36.5308 67.1347 36.0202 67.5356L35.928 67.6079C35.2648 68.1285 34.7308 68.7952 34.3677 69.5561C34.0201 70.2844 33.8378 71.0806 33.8339 71.8876L33.831 72.4806L29.8666 72.2568C29.1768 72.2179 28.6287 71.6627 28.5986 70.9725L28.513 69.0071L28.3337 66.5215C28.3131 66.2364 28.3182 65.95 28.3489 65.6658C28.5749 63.5728 30.081 61.8422 32.1228 61.3294L35.8393 60.396L41.7904 56.5793C42.9413 55.8412 44.2419 55.3682 45.5981 55.1947C48.466 54.8278 51.3656 54.7794 54.2441 55.0504L55.5641 55.1747C58.5298 55.5347 61.4194 56.3635 64.1251 57.63L64.6212 57.8622L70.2761 61.4231C70.5773 61.6128 70.9086 61.7498 71.2558 61.8284L75.4064 62.7675L78.9016 63.9727C79.709 64.2511 80.4812 64.6225 81.2026 65.0795L81.592 65.3261C82.5335 65.9223 83.2621 66.8011 83.6738 67.8365C83.896 68.3953 84.0101 68.9912 84.0101 69.5925V72.2285C84.0101 72.7356 83.5899 73.1418 83.083 73.1247Z"
        fill="white"
        stroke="#99999A"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="39.3387"
        cy="72.0494"
        r="3.35035"
        fill="white"
        stroke="#99999A"
        strokeWidth="1.6638"
      />
      <circle
        cx="73.5018"
        cy="72.0494"
        r="3.43225"
        fill="white"
        stroke="#99999A"
        strokeWidth="1.5"
      />
      <path
        d="M53.1709 57.158L53.3923 61.7721C53.4057 62.0507 53.6323 62.2714 53.9112 62.2774L67.4871 62.5701C67.7653 62.5761 67.8788 62.2148 67.647 62.0607L63.9855 59.6259L63.5125 59.3674C61.1244 58.0626 58.5234 57.1929 55.8308 56.7989L53.7508 56.604C53.4292 56.5738 53.1554 56.8354 53.1709 57.158Z"
        fill="#99999A"
      />
      <path
        d="M41.5328 62.1419L52.1272 62.3113C52.4323 62.3162 52.6787 62.0635 52.6662 61.7586L52.4722 57.0559C52.4605 56.7714 52.2265 56.5469 51.9418 56.5469H48.0827L47.5841 56.5805C45.5311 56.7189 43.6307 57.7134 42.3465 59.3211L41.0911 61.3297C40.8721 61.68 41.1197 62.1353 41.5328 62.1419Z"
        fill="#99999A"
      />
      <path
        d="M60.057 35.1773C60.057 32.8003 59.1477 30.5207 57.5291 28.8399C55.9106 27.1591 53.7154 26.2148 51.4264 26.2148C49.1375 26.2148 46.9423 27.1591 45.3237 28.8399C43.7052 30.5207 42.7959 32.8003 42.7959 35.1773C42.7959 42.9333 49.3743 50.0503 51.0445 51.7323C51.2577 51.9469 51.5958 51.9478 51.8099 51.7341C53.4825 50.0636 60.057 42.9997 60.057 35.1773Z"
        fill="#31B59F"
        stroke="#31B59F"
        strokeWidth="0.99323"
        strokeLinejoin="round"
      />
      <circle
        cx="51.4241"
        cy="34.8465"
        r="4.07249"
        fill="white"
        stroke="white"
        strokeWidth="0.99323"
      />
      <path
        d="M43.5498 63.7246L42.0417 63.7246"
        stroke="#31B59F"
        strokeLinecap="round"
      />
      <path
        d="M55.7202 63.7246L54.2121 63.7246"
        stroke="#31B59F"
        strokeLinecap="round"
      />
      <path
        d="M25.6038 68.6108L22.179 68.6094"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2181 63.916L15.991 63.916"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9185 59.4473L21.7214 59.4473"
        stroke="#31B59F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AddTripIcon
